import "./Settings.css";
import { useState } from "react";
import { Helmet } from "react-helmet";
import Sidebar from "../components/Sidebar/Sidebar";
import Topbar from "../components/Topbar/Topbar";
import PersonalInformation from "./components/PersonalInfomation/PersonalInformation";
import EditPersonalInformation from "./components/PersonalInfomation/EditPersonalInformation/EditPersonalInformation";
import Security from "./components/Security/Security";
import Payouts from "./components/Payouts/Payouts";
import AddPayouts from "./components/AddPayouts/AddPayouts";
import Nav from "./components/Nav/Nav";
import SidebarMobile from "../components/Sidebar/Mobile/SidebarMobile";
import SettingsMobile from "./SettingsMobile/SettingsMobile";

const Settings = () => {
 const [active, setActive] = useState("personalinformation");
 return (
  <div className="settings-dashboard">
   <Helmet>
    <title> Settings | Dashboard | SHAP</title>
    <meta
     name="description"
     content="Knowledge-based digital products distribution at a premium"
    />
   </Helmet>
   <div className="wrapper">
    <div className="side-bar">
     <Sidebar active="settings" />
    </div>
    <div className="side-bar-mobile">
     <SidebarMobile active="settings" />
    </div>

    <div className="content-container">
     <Topbar heading="Settings" />

     <div className="settings-desktop">
      <div className="inner-content">
       <p style={{ color: "var(--primary-grey-text)" }}>
        Dashboard {"  >  "} Settings
       </p>

       <div className="nav-wrapper">
        <Nav active={active} setActive={setActive} />
       </div>

       {active === "personalinformation" && (
        <div className="setting-wrapper">
         <PersonalInformation setActive={setActive} />
        </div>
       )}

       {active === "editpersonalinformation" && (
        <div className="setting-wrapper">
         <EditPersonalInformation setActive={setActive} />
        </div>
       )}

       {active === "addpayouts" && (
        <div className="setting-wrapper">
         <AddPayouts setActive={setActive} />
        </div>
       )}

       {active === "payouts" && (
        <div className="setting-wrapper">
         <Payouts setActive={setActive} />
        </div>
       )}

       {active === "security" && (
        <div className="setting-wrapper">
         <Security />
        </div>
       )}
      </div>
     </div>
     <div className="settings-mobile">
      <SettingsMobile />
     </div>
    </div>
   </div>
  </div>
 );
};

export default Settings;
